'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = List;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function List(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-list', className),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '3' }),
      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '3' }),
      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '7' }),
      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '7' }),
      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '11' }),
      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '11' })
    )
  );
}

List.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/List/List.js
// module id = 1221
// module chunks = 1